// extracted by mini-css-extract-plugin
export default {"Auth":"Auth_Auth__5Njzz","Logo":"Auth_Logo__S7w+E","Title":"Auth_Title__JwsuL","Error":"Auth_Error__yAsYm"};